<div class="back-img change-password-container">
  <div class="side-header-relative">
    <app-auth-side-header></app-auth-side-header>
  </div>

  <div>
    <div class="container back-button back-button-padding">
      <nx-link prominence="subtle" nxStyle="block">
        <a class="back-button-font">
          <nx-icon
            name="arrow-left"
            role="button"
            (click)="toLeave()"
            (keydown.enter)="toLeave()"
            tabindex="0"
          ></nx-icon>
          <p
            role="button"
            (click)="toLeave()"
            (keydown.enter)="toLeave()"
            tabindex="0"
          >
            {{ "CHANGE_PASSWORD.BACK" | translate }}
          </p>
        </a>
      </nx-link>
    </div>

    <div nxCol="12" class="cp-box std-tt-center">
      <div class="cp-title cp-padding module-title-font container">
        {{ "CHANGE_PASSWORD.PASSWORD_EXPIRED" | translate }}
      </div>
      <div
        class="cp-body light-grey-color module-text-font std-tt-center container common-container-padding"
      >
        <p class="label-margin">
          {{ "CHANGE_PASSWORD.SUBTITLE" | translate }}
        </p>
      </div>
    </div>
  </div>

  <div nxRow class="row form-container ie-body">
    <div nxCol="12,12,12,6">
      <div class="pad">
        <div>
          <span class="label-12-font">{{
            "CHANGE_PASSWORD.FORM.SECRET_QUESTION" | translate
          }}</span>
        </div>
        <div>
          <span class="sec-text module-text-font">
            {{ secretQuestionDescp$ | async }}
          </span>
        </div>
      </div>

      <form [formGroup]="profileChangePasswordForm" (ngSubmit)="onSubmit()">
        <nx-formfield
          [label]="'CHANGE_PASSWORD.FORM.SECRET_ANSWER' | translate"
        >
          <input
            class="cp-input-regular"
            formControlName="secretAnswer"
            required
            nxInput
            type="password"
            #secretanswer
          />
          <nx-password-toggle
            [control]="secretanswer"
            [appPasswordTouchToggle]="secretAnswerToggle"
            #secretAnswerToggle
            nxFormfieldSuffix
          ></nx-password-toggle>
          <nx-error nxFormfieldError>
            <b>{{ "FORM_ERRORS.PLEASE_NOTE" | translate }}</b>
            {{ "CHANGE_PASSWORD.FORM.SECRET_ANSWER_REQUIRED" | translate }}
          </nx-error>
        </nx-formfield>

        <nx-formfield
          [label]="'CHANGE_PASSWORD.FORM.CURRENT_PASSWORD' | translate"
        >
          <input
            class="cp-input-regular"
            formControlName="currentPassword"
            required
            nxInput
            type="password"
            #currentpassword
          />
          <nx-password-toggle
            [control]="currentpassword"
            [appPasswordTouchToggle]="currentPasswordToggle"
            #currentPasswordToggle
            nxFormfieldSuffix
          ></nx-password-toggle>
          <nx-error nxFormfieldError>
            <b>{{ "FORM_ERRORS.PLEASE_NOTE" | translate }}</b>
            {{ "CHANGE_PASSWORD.FORM.CURRENT_PASSWORD_REQUIRED" | translate }}
          </nx-error>
        </nx-formfield>

        <nx-formfield [label]="'CHANGE_PASSWORD.FORM.NEW_PASSWORD' | translate">
          <input
            class="cp-input-regular"
            formControlName="newPassword"
            nxInput
            type="password"
          />
          @if (profileChangePasswordForm.controls["newPassword"].valid) {
            <nx-icon class="done-icon"></nx-icon>
          }
          @if (
            newPasswordErrorType !== "samePassword" &&
            profileChangePasswordForm.controls["newPassword"].invalid
          ) {
            <nx-message nxFormfieldNote class="label-16-font fw-regular">
              <div style="margin-bottom: 14px">
                <nx-icon
                  size="s"
                  name="info-circle"
                  class="info-circle"
                ></nx-icon>
                <span>{{ "PASSWORD_VALIDATION.TITLE" | translate }}</span>
              </div>
              <div
                [ngClass]="
                  profileChangePasswordForm.controls['newPassword'].hasError(
                    'required'
                  ) ||
                  profileChangePasswordForm.controls['newPassword'].hasError(
                    'minAndMaxNum'
                  )
                    ? 'text-required'
                    : 'text-success'
                "
              >
                <div class="validator-container">
                  <nx-icon size="s" name="check"></nx-icon>
                </div>
                <p>{{ "PASSWORD_VALIDATION.CHAR_LENGTH" | translate }}</p>
              </div>
              <div
                [ngClass]="
                  profileChangePasswordForm.controls['newPassword'].hasError(
                    'required'
                  ) ||
                  profileChangePasswordForm.controls['newPassword'].hasError(
                    'hasAlphanumeric'
                  )
                    ? 'text-required'
                    : 'text-success'
                "
              >
                <div class="validator-container">
                  <nx-icon size="s" name="check"></nx-icon>
                </div>
                <p>{{ "PASSWORD_VALIDATION.ALPHANUMERIC" | translate }}</p>
              </div>
              <div
                [ngClass]="
                  profileChangePasswordForm.controls['newPassword'].hasError(
                    'required'
                  ) ||
                  profileChangePasswordForm.controls['newPassword'].hasError(
                    'uppercaseAndLowercase'
                  )
                    ? 'text-required'
                    : 'text-success'
                "
              >
                <div class="validator-container">
                  <nx-icon size="s" name="check"></nx-icon>
                </div>
                <p>{{ "PASSWORD_VALIDATION.CASE" | translate }}</p>
              </div>
              <div
                [ngClass]="
                  profileChangePasswordForm.controls['newPassword'].hasError(
                    'required'
                  ) ||
                  profileChangePasswordForm.controls['newPassword'].hasError(
                    'hasSpecialCharacters'
                  )
                    ? 'text-required'
                    : 'text-success'
                "
              >
                <div class="validator-container">
                  <nx-icon size="s" name="check"></nx-icon>
                </div>
                <p>{{ "PASSWORD_VALIDATION.SPECIAL_CHAR" | translate }}</p>
              </div>
            </nx-message>
          }
          @if (newPasswordErrorType === "samePassword") {
            <nx-error nxFormfieldError>
              {{ "CHANGE_PASSWORD.FORM.SAME_PASSWORD_ERROR" | translate }}
            </nx-error>
          }
        </nx-formfield>

        <nx-formfield
          class="pad-save"
          [label]="'CHANGE_PASSWORD.FORM.CONFIRM_NEW_PASSWORD' | translate"
        >
          <input
            class="cp-input-regular"
            formControlName="confirmNewPassword"
            nxInput
            type="password"
          />
          @if (
            profileChangePasswordForm.controls["confirmNewPassword"].value !==
              "" &&
            profileChangePasswordForm.controls["confirmNewPassword"].valid &&
            profileChangePasswordForm.controls["newPassword"].value ===
              profileChangePasswordForm.controls["confirmNewPassword"].value
          ) {
            <nx-icon class="done-icon"></nx-icon>
          }
          <nx-error nxFormfieldError>
            @if (confirmNewPasswordErrorType === "required") {
              <b>{{ "FORM_ERRORS.PLEASE_NOTE" | translate }}</b>
              {{ "CHANGE_PASSWORD.FORM.CONFIRM_PASSWORD_REQUIRED" | translate }}
            }
            @if (confirmNewPasswordErrorType === "passwordMisMatch") {
              <div class="error-title password-mismatch">
                Your passwords do not match
              </div>
              Please try again.
            }
          </nx-error>
        </nx-formfield>

        @if (backendError) {
          <nx-error nxFormfieldError>
            @if (changePasswordErrorMsg) {
              <div>
                <p
                  class="error-title match-error-title label-16-font fw-semi-bold"
                >
                  {{ changePasswordErrorTitle }}
                </p>
                <p class="match-error-text label-16-font">
                  {{ changePasswordErrorMsg }}
                </p>
              </div>
            }
            @if (!changePasswordErrorMsg) {
              <p class="match-error-text label-16-font">
                {{ changePasswordErrorTitle }}
              </p>
            }
          </nx-error>
        }

        <div class="update-button">
          <button
            nxButton
            type="submit"
            [disabled]="
              !(
                profileChangePasswordForm.controls['confirmNewPassword']
                  .valid &&
                profileChangePasswordForm.controls['newPassword'].valid &&
                profileChangePasswordForm.controls['newPassword'].value ===
                  profileChangePasswordForm.controls['confirmNewPassword'].value
              )
            "
            class="site-header__button button-font"
            nxButton="block primary"
          >
            {{ "CHANGE_PASSWORD.FORM.SAVE_UPDATE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
